module.exports = __webpack_public_path__ + "static/media/find_your_perfect_team.bcf70762.png";